/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */
import {
  createStyledComponent,
  getNormalizedValue,
  pxToEm
} from '../../../../styles';
import Heading from '../../SiteHeading';

export default createStyledComponent(Heading, ({ theme }) => ({
  margin: `0 0 ${getNormalizedValue(
    pxToEm(21 - 12), // to mid-baseline
    theme.SiteHeading_fontSize_3
  )}`,
  paddingTop: getNormalizedValue(
    pxToEm(50), // to baseline
    theme.SiteHeading_fontSize_3
  ),

  [theme.bp_moreSpacious]: {
    fontSize: theme.SiteHeading_fontSize_3_wide,
    margin: `0 0 ${getNormalizedValue(
      pxToEm(19 - 12), // to mid-baseline
      theme.SiteHeading_fontSize_3_wide
    )}`,
    paddingTop: getNormalizedValue(
      pxToEm(55), // to baseline
      theme.SiteHeading_fontSize_3_wide
    )
  }
})).withProps({ level: 3 });



// WEBPACK FOOTER //
// ./src/website/app/pages/ComponentDoc/DocSectionTitle.js